import AsyncLimit from "../common/AsyncLimit";
import hdapi from "../common/hdapi";
import Converter, {ConverterStates} from "./Converter";

export default class ImageConverter extends Converter {
	constructor() {
		super();
		this.options = {
			compressLevel: 1, // 0: 缩小优先 1:清晰优先
			outputExt: "", // '':格式不变 png|jpg 其它格式
		};
		this._queue = new AsyncLimit(2);
		this._ysType = "视频压缩";
		this.nowFileArry = [];
	}
	loadFile(path, isAFilePush, url, i) {
		return super.loadFile(path, i).then((file) => {
			return hdapi
				.getVideoInfo(path)
				.catch((x) => {
					console.log("err======", x);
					return 0;
				})
				.then((info) => {
					console.log("info", info);
					if (isAFilePush) {
						file.isAFilePush = isAFilePush;
						file.OriginFilePushPath = url;
					}
					if (info && info.streams && info.streams[0]) {
						let stream = info.streams[0];
						file.is_video_bitrate = false;
						file.is_video_fps = false;
						file.is_music_bitrate = false;
						file.is_music_samplingrate = false;
						file.is_gx_resolution = false;
						file.bitrate = Number(stream.bit_rate ? stream.bit_rate : info.format.bit_rate);
						file.video_bitrate = 85;
						file.video_fps = 0;
						file.music_bitrate = 0;
						file.music_samplingrate = 0;
						file.gx_aspect_ratio = 100;
						file.gx_width = stream.width;
						file.gx_height = stream.height;
						file.width = stream.width;
						file.height = stream.height;
						file.state = ConverterStates.WAIT;
					} else {
						file.is_video_bitrate = false;
						file.is_video_fps = false;
						file.is_music_bitrate = false;
						file.is_music_samplingrate = false;
						file.gx_aspect_ratio = 100;
						file.video_bitrate = 0;
						file.video_fps = 0;
						file.music_bitrate = 0;
						file.music_samplingrate = 0;
						file.is_gx_resolution = false;
						file.gx_width = 0;
						file.gx_height = 0;
						file.bitrate = 0;
						file.width = 0;
						file.height = 0;
						file.state = ConverterStates.BROKE_FILE;
					}
					return file;
				});
		});
	}
	async doConvert(file, dir, i) {
		if (i == null) {
			i = "";
			file.filename = hdapi.filename(file.path);
		}
		// console.log("压缩第", i, "次");
		var ext = this.options.outputExt;
		ext = ext ? "." + ext : hdapi.extname(file.path);
		if (i == "") {
			if (this.nowFileArry.indexOf(file.filename) == -1) {
				this.nowFileArry.push(file.filename);
			} else {
				var a = hdapi.extname(file.path).split(".");
				file.filename += `-` + a[1];
				this.checkIsSameFileName(file);
			}
			var outfile = file.filename + ext;
		} else {
			var b = file.filename + `-${i}`;
			this.nowFileArry.push(b);
			var outfile = b + ext;
		}
		var compressratio = this.options.compressLevel ? 85 : 60;
		var _this = this;
		var tempFile = (await hdapi.getPath("temp")) + "/progress_" + Math.random();
		// console.log("outfile", outfile);
		if (file.isAFilePush) {
			if (window.store.local.outputOriginDir) {
				file.outpath = hdapi.join(file.outputOriginDir, outfile);
			} else {
				file.outpath = hdapi.join(file.outputCustomDir, outfile);
			}
			// return;
		} else file.outpath = hdapi.join(dir, outfile);
		let exist = await hdapi.exists(file.outpath);
		if (exist) {
			return this.doConvert(file, dir, i == "" ? 1 : ++i);
		}
		var handle = setInterval(function () {
			hdapi
				.readFile(tempFile, "utf8")
				.catch((x) => "")
				.then((text) => {
					console.log("temp=", text);
					if (hdapi.platform == "MAC") {
						if (!file.progress_time) {
							_this.setTimeCheckProgress(file);
						}
					} else if (hdapi.platform == "WIN") {
						var ss = text.split("=");
						for (let i = ss.length - 1; i >= 0; i--) {
							let p = parseFloat(ss[i]);
							if (!isNaN(p)) {
								file.progress = p;
								break;
							}
						}
					}
				});
		}, 1e3);
		// mac
		if (hdapi.platform == "MAC") {
			console.log("mac视频压缩 ");
			if (
				file.is_video_bitrate ||
				file.is_video_fps ||
				file.is_music_bitrate ||
				file.is_music_samplingrate ||
				file.is_gx_resolution
			) {
				let yswidth = Math.floor(file.is_gx_resolution ? file.gx_width : file.width);
				let ysheight = Math.floor(file.is_gx_resolution ? file.gx_height : file.height);
				let ysarray = [`ffmpeg`, `-hide_banner`, `-i`, file.path, `-s`, `${yswidth}x${ysheight}`];
				if (file.is_video_bitrate) {
					// console.log(file.bitrate, file.video_bitrate);
					ysarray.push(`-b:v`, `${Math.floor((file.video_bitrate * file.bitrate) / 100000)}k`);
				} else {
					ysarray.push(`-b:v`, `${Math.floor((85 * file.bitrate) / 100000)}k`);
				}
				if (file.is_music_bitrate && file.music_bitrate != 0) {
					ysarray.push(`-b:a`, `${file.music_bitrate}k`);
				}
				if (file.is_video_fps && file.video_fps != 0) {
					ysarray.push(`-r`, file.video_fps);
				}
				if (file.is_music_samplingrate && file.music_samplingrate != 0) {
					ysarray.push(`-ar`, file.music_samplingrate * 1000);
				}
				ysarray.push(file.outpath, `-progress`, tempFile);
				console.log("ysarray", ysarray);
				return hdapi
					.procCreate(ysarray, {spawnMode: true})
					.then((x) => {
						file._proc = x;
						return x.wait();
					})
					.finally(() => {
						clearInterval(handle);
						hdapi.unlink(tempFile);
					});
			}
			return hdapi
				.procCreate(
					[
						`ffmpeg`,
						`-hide_banner`,
						`-i`,
						file.path,
						`-b:v`,
						`${Math.floor((compressratio * file.bitrate) / 100000)}k`,
						file.outpath,
						`-progress`,
						tempFile,
					],
					{spawnMode: true}
				)
				.then((x) => {
					file._proc = x;
					return x.wait();
				})
				.finally(() => {
					clearInterval(handle);
					hdapi.unlink(tempFile);
				});
		}
		// win
		else if (hdapi.platform == "WIN") {
			if (
				file.is_video_bitrate ||
				file.is_video_fps ||
				file.is_music_bitrate ||
				file.is_music_samplingrate ||
				file.is_gx_resolution
			) {
				let yswidth = Math.floor(file.is_gx_resolution ? file.gx_width : file.width);
				let ysheight = Math.floor(file.is_gx_resolution ? file.gx_height : file.height);
				let ysarray = [
					`VideoConverterSdk`,
					`--type`,
					`compress`,
					`--subtype`,
					`custom`,
					`-i`,
					file.path,
					`-s`,
					`${yswidth}x${ysheight}`,
				];
				if (file.is_video_bitrate) {
					// console.log(file.bitrate, file.video_bitrate);
					ysarray.push(`-b:v`, `${Math.floor((file.video_bitrate * file.bitrate) / 100000)}k`);
				} else {
					ysarray.push(`-b:v`, `${Math.floor((85 * file.bitrate) / 100000)}k`);
				}
				if (file.is_music_bitrate && file.music_bitrate != 0) {
					ysarray.push(`-b:a`, `${file.music_bitrate}k`);
				}
				if (file.is_video_fps && file.video_fps != 0) {
					ysarray.push(`-r`, file.video_fps);
				}
				if (file.is_music_samplingrate && file.music_samplingrate != 0) {
					ysarray.push(`-ar`, file.music_samplingrate * 1000);
				}
				ysarray.push(file.outpath, `-progress`, tempFile);
				console.log("ysarray", ysarray);
				return hdapi
					.procCreate(ysarray, {spawnMode: true})
					.then((x) => {
						file._proc = x;
						return x.wait();
					})
					.finally(() => {
						clearInterval(handle);
						hdapi.unlink(tempFile);
					});
			}
			return hdapi
				.procCreate(
					[
						`VideoConverterSdk`,
						`--type`,
						`compress`,
						`--subtype`,
						`custom`,
						`-i`,
						file.path,
						`-b:v`,
						`${Math.floor((compressratio * file.bitrate) / 100000)}k`,
						file.outpath,
						`-progress`,
						tempFile,
					],
					{spawnMode: true}
				)
				.then((x) => {
					file._proc = x;
					return x.wait();
				})
				.finally(() => {
					clearInterval(handle);
					hdapi.unlink(tempFile);
				});
		}
	}
	setTimeCheckProgress(file) {
		// let that = this;
		file.progress_time = setInterval(function () {
			// console.log("progress", file.progress);
			if (file.progress < 0.8) file.progress += 0.01;
			if (file.state != 2) {
				file.progress = 0;
				clearInterval(file.progress_time);
			}
		}, 50);
	}

	checkIsSameFileName(file, i) {
		if (!i) i = 1;
		if (this.nowFileArry.indexOf(file.filename) == -1) {
			this.nowFileArry.push(file.filename);
			return;
		} else {
			file.filename = file.filename + `(${i})`;
			this.checkIsSameFileName(file, i);
		}
	}
}
